var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.37 50.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-caracteristicas_selecionado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.59,29.88c-4.3.63-6.09,4.1-7,8A28.19,28.19,0,0,0,0,44.75a6,6,0,0,0,2.61,5c2.05,1.36,4.06,1.1,6.39,1.1H24.07c2,0,5.51.22,7.27-.3C36.1,49.08,36,44.1,35.39,40.06,34.88,36.47,33.64,32,30,30.38c-5-2.2-4.33,2-11.07,2.8-3.48.4-5.88-.85-8.5-2.54-1.29-.83-1.22-1-2.84-.76Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.68,12.07a9.17,9.17,0,0,0-6.37,3.39A9.78,9.78,0,0,0,11.58,29.2a9.35,9.35,0,0,0,7.36,2.18c5.33-.37,9.15-5.58,8.55-10.8a9.61,9.61,0,0,0-10.81-8.51Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.47,49.25l-7.38-5.44c-1.31-1-.81-2.18-.81-3.61l8.18,6.06,8.19-6.06c0,1.91.61,2.56-1.16,3.87l-7,5.18Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.53,13.58a9.57,9.57,0,0,0,.09-1.21,9.59,9.59,0,0,0-.09-1.22l2.61-2a.61.61,0,0,0,.15-.79L58.82,4a.63.63,0,0,0-.55-.3.76.76,0,0,0-.21,0L55,5A9.1,9.1,0,0,0,52.9,3.8L52.43.52A.61.61,0,0,0,51.82,0h-5a.6.6,0,0,0-.6.52L45.8,3.8A9.42,9.42,0,0,0,43.71,5L40.63,3.77a.83.83,0,0,0-.22,0,.62.62,0,0,0-.53.3L37.4,8.32a.61.61,0,0,0,.15.79l2.61,2a9.87,9.87,0,0,0-.09,1.22,9.85,9.85,0,0,0,.09,1.21l-2.61,2a.63.63,0,0,0-.15.79l2.48,4.28a.62.62,0,0,0,.54.3.71.71,0,0,0,.21,0l3.08-1.24a8.38,8.38,0,0,0,2.09,1.21l.47,3.28a.59.59,0,0,0,.6.52h5a.59.59,0,0,0,.6-.52l.47-3.28A9,9,0,0,0,55,19.72L58.06,21a.91.91,0,0,0,.23,0,.62.62,0,0,0,.53-.3l2.47-4.28a.61.61,0,0,0-.15-.79l-2.61-2h0Zm-2.44-2.12a8.74,8.74,0,0,1,.06.91c0,.25,0,.53-.06.9l-.18,1.39,1.1.87,1.34,1-.87,1.49-1.57-.63-1.28-.52-1.12.84a7,7,0,0,1-1.54.91l-1.31.53-.2,1.39-.25,1.67H48.48l-.23-1.67-.2-1.39-1.31-.53a7.31,7.31,0,0,1-1.52-.88l-1.13-.87-1.31.53-1.57.63-.87-1.49,1.34-1,1.1-.87-.17-1.39a8.91,8.91,0,0,1-.06-.92,8.58,8.58,0,0,1,.06-.9l.17-1.4-1.1-.86-1.34-1,.87-1.5,1.57.63,1.29.52L45.18,7a7.57,7.57,0,0,1,1.54-.9L48,5.54l.2-1.4.25-1.67H50.2l.24,1.67.19,1.4,1.31.53A7,7,0,0,1,53.47,7l1.12.86,1.31-.53,1.57-.63.87,1.5L57,9.2l-1.1.87.18,1.39Zm-6.74-4a4.95,4.95,0,1,0,4.94,4.95A4.94,4.94,0,0,0,49.35,7.42Zm0,7.42a2.48,2.48,0,1,1,2.47-2.47A2.48,2.48,0,0,1,49.35,14.84Z",
    transform: "translate(0 0)",
    fill: "#ed7333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.47,49.25l-7.38-5.44c-1.31-1-.81-2.18-.81-3.61l8.18,6.06,8.19-6.06c0,1.91.61,2.56-1.16,3.87l-7,5.18Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.31,29.08V47.17h2.31V29.47A17.4,17.4,0,0,1,45.31,29.08Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG4);
export default __webpack_public_path__ + "static/media/G4.ce4edededdf746a4c035669aefd5f444.svg";
export { ForwardRef as ReactComponent };